import {
  ScopeOfPracticeEnum,
  ShiftStatusEnum,
  ShiftTypeEnum
} from '@umss/shared/utils';
import { ShiftNeedSearchDto } from '../dtos/shift-need-search.dto';

/**
 * Options for building a ShiftNeedSearchDto
 */
export interface ShiftSearchOptions {
  contractorId?: string;
  scopesOfPractice?: ScopeOfPracticeEnum[];
  shiftTypes?: ShiftTypeEnum[];
  startDate?: string;
  endDate?: string;
  minHourlyRate?: number;
  maxHourlyRate?: number;
  searchTerm?: string;
  maxDistanceMiles?: number;
  pageSize?: number;
  pageNumber?: number;
  excludeExpired?: boolean;
  excludeConflictsForContractor?: boolean;
  excludeStarted?: boolean;
}

/**
 * Builds a ShiftNeedSearchDto with consistent defaults
 *
 * SINGLE SOURCE OF TRUTH for shift search parameters
 * - Always includes Posted and PartiallyFilled statuses
 * - Default page size is 50
 * - Default page number is 1
 *
 * Used by:
 * - Dashboard service for urgent shifts
 * - Feature-shifts service for all shift searches
 *
 * @param options - Search options
 * @returns ShiftNeedSearchDto ready for API call
 */
export function buildShiftNeedSearchDto(
  options: ShiftSearchOptions = {}
): ShiftNeedSearchDto {
  return {
    contractorId: options.contractorId,
    scopesOfPractice: options.scopesOfPractice,
    shiftTypes: options.shiftTypes,
    statuses: [
      ShiftStatusEnum.Posted,
      ShiftStatusEnum.PartiallyFilled,
      ShiftStatusEnum.InProgress
    ],
    startDate: options.startDate,
    endDate: options.endDate,
    minHourlyRate: options.minHourlyRate,
    maxHourlyRate: options.maxHourlyRate,
    searchTerm: options.searchTerm,
    contractorIdForDistance: options.contractorId,
    maxDistanceMiles: options.maxDistanceMiles,
    pageSize: options.pageSize ?? 50,
    pageNumber: options.pageNumber ?? 1,
    excludeExpired: options.excludeExpired,
    excludeConflictsForContractor: options.excludeConflictsForContractor,
    excludeStarted: options.excludeStarted
  };
}
